"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeparture = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    getDeparture: function getDeparture(countryID, selectedDepartureIDs, selectedTransports, onSuccess) {
      return {
        countryID: countryID,
        selectedDepartureIDs: selectedDepartureIDs,
        selectedTransports: selectedTransports,
        onSuccess: onSuccess
      };
    }
  }, {
    prefix: 'TS_SEARCH_FORM_COUNTRY_CONTROL'
  }),
  getDeparture = exports.getDeparture = _createActions.getDeparture;